export const LOAD_MAP_GEOJSON = '[MAP] LOAD_GEOJSON';
export const LOAD_MAP_GEOJSON_SUCCESS = '[MAP] LOAD_GEOJSON_SUCCESS';
export const LOAD_MAP_GEOJSON_FAILURE = '[MAP] LOAD_GEOJSON_FAILURE';

export const loadMapGeoJSON = url => ({ type: LOAD_MAP_GEOJSON, payload: url });
export const loadMapGeoJSONSuccess = data => ({ type: LOAD_MAP_GEOJSON_SUCCESS, payload: data });
export const loadMapGeoJSONFailure = error => ({ type: LOAD_MAP_GEOJSON_FAILURE, payload: error });
